import { createSelector } from '@reduxjs/toolkit';
import { selectDetails } from './../../../details/store/selectors';

export const selectBeneficiaries = createSelector(selectDetails, (details) => details.superSimplifierbeneficiaries.beneficiaries);
